import { Lock } from 'lucide-react'
import type { LockedFieldsProps } from './locked-fields.interface'
import classes from './locked-fields.module.scss'

const LOCKED_CAPTION = "Always asked · can't be edited or removed"
const CONTACT_FIELDS = ['Name', 'Phone', 'Email']
const ADDRESS_FIELD = 'Address'

export function LockedFields({ showAddressField }: LockedFieldsProps) {
  return (
    <div className={classes.root} data-testid="locked-fields">
      <div className={classes.caption}>
        <Lock size={12} strokeWidth={2.2} aria-hidden="true" />
        {LOCKED_CAPTION}
      </div>
      <div className={classes.fields}>
        <div className={classes.contactGrid}>
          {CONTACT_FIELDS.map((label) => (
            <LockedField key={label} label={label} />
          ))}
        </div>
        {showAddressField && <LockedField label={ADDRESS_FIELD} />}
      </div>
    </div>
  )
}

function LockedField({ label }: { label: string }) {
  return (
    <div className={classes.field}>
      <div className={classes.label}>
        {label} <span className={classes.required}>*</span>
      </div>
      <div className={classes.input} aria-hidden="true" />
    </div>
  )
}
